<template>
  <div class="col-12 stationTable customFooBTableArea">
    <!-- table search start -->
    <div class="row justify-content-between marginBottomNegative25">
      <div class="col-auto dataTableInput d-flex align-items-center">
        <div class="row">
          <div :class="$slots.baseSelect ? 'col-6' : 'col-12'">
            <slot name="selectedEntityName" />
          </div>
        </div>
      </div>
      <!--leftAnimateInput-->
      <div class="col-auto selectNoBorder pr-0">
        <div class="row customRow8">
          <div class="col customPadding8">
            <base-input :input-class="'mb-0 fooTableFilterInput'" :form-group-class="'mb-0'" @input.native="setSearchModel($event)" />
          </div>
          <div class="col customPadding8">
            <multi-select-wrapper
              v-model="perPageCopy"
              :options="pageOptions"
              :text-field="'text'"
              :value-field="'value'"
              :placeholder="'1-10 Arası'"
              :form-group-class="['mb-0', 'selectCustomWidth']"
              :searchable="false"
              @input="handlePerPageSelectValue($event)"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- table search end -->

    <div class="darkBlueGreyTable customBFooTable mt-0">
      <b-table
        :striped="striped"
        :items="filteredItems"
        :fields="filteredFields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filterTableInputSearchHistory"
        :thead-tr-class="theadTrClass"
        :class="tableClass"
        :hover="hover"
        :empty-filtered-text="emptyFilteredText"
        :empty-text="emptyText"
        :show-empty="showEmpty"
        :responsive="responsive"
        :fixed="fixed"
        :sort-compare="customSortingProp ? customSortingProp : customSorting"
        :filter-included-fields="filterIncludedFields"
        :filter-function="filterTable"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @filtered="onFiltered"
        @row-clicked="selectedEntityRowClicked"
        @row-selected="selectedEntityRowClicked"
      >
        <!-- body  -->

        <!--            radio check cell start-->
        <template #cell(number)="data">
          <div class="d-flex align-items-center">
            <!--            <span class="d-flex" v-if="bTableWidthHistory <= 500">-->
            <!--              <i @click="btnToggleDetails(data)" :class="data.detailsShowing ? 'btnTableMinus' : 'btnTablePlus'"></i>-->
            <!--            </span>-->
            <span>
              {{ inputToUpperCase(data.item.model.number) }}
            </span>
          </div>
        </template>
        <template #cell(trainInfoName)="data">
          <div class="d-flex align-items-center">
            <!--            <span class="d-flex" v-if="bTableWidthHistory <= 500">-->
            <!--              <i @click="btnToggleDetails(data)" :class="data.detailsShowing ? 'btnTableMinus' : 'btnTablePlus'"></i>-->
            <!--            </span>-->
            <!-- history -->
            <span>
              {{ inputToUpperCase(data.item.model.trainInfoName) }}
            </span>
          </div>
        </template>
        <template #cell(lineName)="data">
          <div class="d-flex align-items-center">
            <!--            <span class="d-flex" v-if="bTableWidthHistory <= 500">-->
            <!--              <i @click="btnToggleDetails(data)" :class="data.detailsShowing ? 'btnTableMinus' : 'btnTablePlus'"></i>-->
            <!--            </span>-->
            <span>
              {{ inputToUpperCase(data.item.model.lineName) }}
            </span>
          </div>
        </template>
        <template #cell(name)="data">
          <div class="d-flex align-items-center">
            <!--            <span class="d-flex" v-if="bTableWidthHistory <= 500">-->
            <!--              <i @click="btnToggleDetails(data)" :class="data.detailsShowing ? 'btnTableMinus' : 'btnTablePlus'"></i>-->
            <!--            </span>-->
            <span>
              {{ inputToUpperCase(data.item.model.name) }}
            </span>
          </div>
        </template>
        <template #cell(stationTypeName)="data">
          <div class="d-flex align-items-center">
            <span>
              {{ data.item.model.stationType.name ? inputToUpperCase(data.item.model.stationType.name) : inputToUpperCase(emptyText) }}
            </span>
          </div>
        </template>

        <template #cell(detail)="data">
          <div class="d-flex align-items-center">
            <span>
              {{ data.item.model.detail ? inputToUpperCase(data.item.model.detail) : inputToUpperCase(emptyText) }}
            </span>
          </div>
        </template>

        <template #cell(characteristic)="data">
          <div class="d-flex align-items-center">
            <span>
              {{ data.item.model ? inputToUpperCase(translateCharacteristic(data.item.model.characteristic)) : inputToUpperCase(emptyText) }}
            </span>
          </div>
        </template>

        <template #cell(saleOpenStatus)="data">
          <div class="d-flex align-items-center">
            <span>
              {{ data.item.model ? inputToUpperCase(translateSaleOpenStatus(data.item.model.saleOpen)) : inputToUpperCase(emptyText) }}
            </span>
          </div>
        </template>

        <template #cell(code)="data">
          <div class="d-flex align-items-center">
            <span>
              {{ data.item.model ? inputToUpperCase(data.item.model.code) : inputToUpperCase(emptyText) }}
            </span>
          </div>
        </template>

        <template #cell(additionalServiceLineName)="data">
          <div class="d-flex align-items-center">
            <span>
              {{ data.item.model ? inputToUpperCase(data.item.model.additionalServiceLineName) : inputToUpperCase(emptyText) }}
            </span>
          </div>
        </template>

        <template #cell(fromSeatMapTemplateName)="data">
          <div class="d-flex align-items-center">
            <span>
              {{ data.item.model ? inputToUpperCase(data.item.model.fromSeatMapTemplateName) : inputToUpperCase(emptyText) }}
            </span>
          </div>
        </template>

        <template #cell(username)="data">
          <div class="d-flex align-items-center">
            <span>
              {{ data.item ? inputToUpperCase(data.item.username) : inputToUpperCase(emptyText) }}
            </span>
          </div>
        </template>

        <template #cell(title)="data">
          <div class="d-flex align-items-center">
            <!--            <span class="d-flex" v-if="bTableWidthHistory <= 500">-->
            <!--              <i @click="btnToggleDetails(data)" :class="data.detailsShowing ? 'btnTableMinus' : 'btnTablePlus'"></i>-->
            <!--            </span>-->
            <span>
              {{ inputToUpperCase(data.item.model.title) }}
            </span>
          </div>
        </template>
        <template #cell(fromTrainName)="data">
          <div class="d-flex align-items-center">
            <!--            <span class="d-flex" v-if="bTableWidthHistory <= 500">-->
            <!--              <i @click="btnToggleDetails(data)" :class="data.detailsShowing ? 'btnTableMinus' : 'btnTablePlus'"></i>-->
            <!--            </span>-->
            <!-- history -->
            <span>
              {{ inputToUpperCase(data.item.model.fromTrainName) }}
            </span>
          </div>
        </template>
        <template #cell(bookingClassCode)="data">
          <div class="d-flex align-items-center">
            <!--            <span class="d-flex" v-if="bTableWidthHistory <= 500">-->
            <!--              <i @click="btnToggleDetails(data)" :class="data.detailsShowing ? 'btnTableMinus' : 'btnTablePlus'"></i>-->
            <!--            </span>-->
            <!-- history -->
            <span>
              {{ inputToUpperCase(data.item.model.bookingClassCode) }}
            </span>
          </div>
        </template>
        <template #cell(orerNoAndVersionNoAndKKYNo)="data">
          <div class="d-flex align-items-center">
            <!--            <span class="d-flex" v-if="bTableWidthHistory <= 500">-->
            <!--              <i @click="btnToggleDetails(data)" :class="data.detailsShowing ? 'btnTableMinus' : 'btnTablePlus'"></i>-->
            <!--            </span>-->
            <!-- history -->
            <span>
              {{ inputToUpperCase(data.item.model.orerNoAndVersionNoAndKKYNo) }}
            </span>
          </div>
        </template>
        <!--            radio check cell end-->

        <template #cell(toTrainName)="data">{{ inputToUpperCase(data.item.model.toTrainName) }}</template>
        <template #cell(connectingTrainName)="data">{{ inputToUpperCase(data.item.model.connectingTrainName) }}</template>
        <template #cell(lastUpdateDate)="data">
          {{ inputToUpperCase(addThreeHourToHour(data.item.updateDate)) }}
        </template>
        <template #cell(user)="data">
          {{ data.item.user === null || data.item.user === undefined ? "Demo Kullanıcı" : inputToUpperCase(data.item.user) }}
        </template>
        <template #cell(userId)="data">
          {{ data.item.userId === null || data.item.userId === undefined ? "Demo Kullanıcı" : inputToUpperCase(data.item.userId) }}
        </template>
        <template #cell(status)="data">
          {{ inputToUpperCase(translateStatus(data.item.status)) }}
        </template>
        <template #cell(createDate)="data">
          {{ inputToUpperCase(getFormattedDate(data.item.createDate)) }}
        </template>
        <template #emptyfiltered="{ emptyFilteredText }">
          <div class="text-center">
            <p class="m-0">{{ inputToUpperCase(emptyFilteredText) }}</p>
          </div>
        </template>
        <template #empty="{ emptyText }">
          <div class="text-center">
            <p class="m-0">{{ inputToUpperCase(emptyText) }}</p>
          </div>
        </template>
        <template #cell(firstName)="data">
          <slot name="tooltips" :selected-row="data.item.firstName" />
          <!--{{ data.item.firstName }}-->
        </template>

        <template #cell(typeNameView)="data">
          <slot name="customElement" :selected-row="data.item" />
        </template>

        <!-- details -->
        <template v-if="bTableWidthHistory <= 500" #row-details="row">
          <ul class="detailsUL row">
            <li v-if="bTableWidthHistory <= 500" class="col-12">
              <div class="row">
                <span class="col-auto font-weight-bold">Durum:</span>
                <span class="col d-flex">
                  {{ inputToUpperCase(translateStatus(row.status)) }}
                </span>
              </div>
            </li>
          </ul>
        </template>
      </b-table>
    </div>

    <div class="row">
      <div class="col-12 pageNavigation">
        <b-pagination
          v-model="currentPageCopy"
          :total-rows="totalRows"
          :per-page="perPage"
          size="sm"
          :limit="limitPagination"
          :first-number="firstNumberPagination"
          :last-number="lastNumberPagination"
        >
          <template #prev-text>
            <a class="page-link">
              <span><i class="navigationArrowLeft" /></span>
            </a>
          </template>
          <template #next-text>
            <a class="page-link">
              <span><i class="navigationArrowRight" /></span>
            </a>
          </template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import BaseInput from "./element/form/input/BaseInput.vue";
import commonEntityProperties from "../mixins/commonEntityProperties";
import enumHelper from "../util/enumHelper";
import moment from "moment";
import MultiSelectWrapper from "./element/form/select/MultiSelectWrapper.vue";

export default {
  name: "HistoryFooTable",
  components: { MultiSelectWrapper, BaseInput },
  mixins: [commonEntityProperties],
  props: {
    pageName: {
      type: String,
      default: "",
    },
    totalRows: {
      type: Number,
      default: 1,
      required: true,
    },
    filteredItems: {
      type: Array,
      default: () => [],
      required: true,
    },
    filteredFields: {
      type: Array,
      default: () => [],
      required: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    theadTrClass: {
      type: String,
      default: "bgDarkBlueGrey",
    },
    tableClass: {
      type: String,
      default: null,
    },
    hover: {
      type: Boolean,
      default: true,
    },
    responsive: {
      type: [String, Boolean],
      default: true,
    },
    fixed: {
      type: Boolean,
      default: true,
    },
    emptyFilteredText: {
      type: String,
      default: "Aradığınız kayıt bulunamadı.",
    },
    emptyText: {
      type: String,
      default: "Kayıt bulunamadı.",
    },
    showEmpty: {
      type: Boolean,
      default: true,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    limitPagination: {
      type: Number,
      default: 10,
    },
    firstNumberPagination: {
      type: Boolean,
      default: true,
    },
    lastNumberPagination: {
      type: Boolean,
      default: true,
    },
    bTableWidthHistory: {
      type: Number,
      default: 0,
    },
    filterIncludedFields: {
      type: Array,
      default: () => [],
    },
    sortBy: {
      type: String,
      default: "updateDate",
    },
    sortDesc: {
      type: Boolean,
      default: true,
    },
    customSortingProp: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      pageOptions: [
        { value: 30, text: "1-30 Arası" },
        { value: 50, text: "1-50 Arası" },
      ],
      filterTableInputSearchHistory: null,
    };
  },
  computed: {
    moment() {
      return moment;
    },
    enumHelper() {
      return enumHelper;
    },
    currentPageCopy: {
      get() {
        return this.currentPage;
      },
      set(value) {
        this.$emit("update:currentPage", value);
      },
    },
    perPageCopy: {
      get() {
        return this.perPage;
      },
      set(value) {
        this.$emit("update:perPage", value);
      },
    },
  },

  methods: {
    translateSaleOpenStatus(saleOpenStatus) {
      if (saleOpenStatus === false) {
        return "Kapalı";
      } else {
        return "Açık";
      }
    },
    translateCharacteristic(characteristic) {
      if (characteristic === false) {
        return "Hayır";
      } else {
        return "Evet";
      }
    },
    addThreeHourToHour(date) {
      return date ? moment(date).add(3, "hour").format("DD.MM.YYYY HH:mm") : "Tarih Yok";
    },
    translateStatus(status) {
      switch (status) {
        case "DRAFT":
          return "Taslak";
        case "WAITING_APPROVAL":
          return "Onay Bekliyor";
        case "OVERRIDDEN":
          return "Değiştirilmiş";
        case "PUBLISHED":
          return "Yayında";
        case "UNPUBLISHED":
          return "Yayınlanmamış";
        case "CANCELLED":
          return "İptal";
        default:
          return status;
      }
    },
    setSearchModel(event) {
      clearTimeout(this.$_timeout);
      this.$_timeout = setTimeout(() => {
        Vue.set(this, "filterTableInputSearchHistory", event.target.value);
      }, 300); // set this value to your preferred debounce timeout
    },

    filterTable(rowObject, searchText) {
      for (let i = 0; i < this.filterIncludedFields.length; i++) {
        if (rowObject[this.filterIncludedFields[i]]) {
          if (rowObject[this.filterIncludedFields[i]].toString().toLocaleUpperCase("tr-TR").indexOf(searchText.toLocaleUpperCase("tr-TR")) !== -1) {
            return true;
          }
        }
      }
    },

    customSorting(a, b, key) {
      if (typeof a[key] === "number" && typeof b[key] === "number") {
        // If both compared fields are native numbers
        return a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0;
      } else {
        // Stringify the field data and use String.localeCompare
        return this.toStringMthod(a[key]).localeCompare(this.toStringMthod(b[key]), undefined, {
          numeric: true,
        });
      }
    },
    toStringMthod(value) {
      if (!value) {
        return "";
      } else if (value instanceof Object) {
        return Object.keys(value)
          .sort()
          .map((key) => toString(value[key]))
          .join(" ");
      }
      return String(value);
    },
    onFiltered(onFilteredItems) {
      this.$emit("onFiltered", onFilteredItems);
    },
    // btnToggleDetails(item) {
    //   item.toggleDetails();
    //   item.detailsShowing = !item.detailsShowing;
    // },
    selectedEntityRowClicked(selectedEntity) {
      this.$emit("selectedEntityRowClicked", selectedEntity);
    },
    getFormattedDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm");
    },
    inputToUpperCase(event) {
      if (typeof event === "string" && event) {
        return event.toLocaleUpperCase("tr-TR");
      } else {
        return event;
      }
    },
    handlePerPageSelectValue(event) {
      if (!event) {
        this.perPageCopy = 10;
      }
    },
  },
};
</script>

<style scoped>
.marginBottomNegative25 {
  margin-bottom: -25px;
}
</style>
